import api from "./axios";
import { BLOGS, BLOGS_HOME, BLOGS_SEARCH } from "./apis";

const buildBlogQuery = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    query.set(key, String(value));
  });

  const qs = query.toString();
  return qs ? `${BLOGS}?${qs}` : BLOGS;
};

const unwrap = (payload) => {
  if (payload?.ok === false) {
    throw new Error(payload?.message || "Something went wrong");
  }
  return payload;
};

/** api blogs — list with optional filters */
export const fetchBlogs = async ({
  q,
  page = 0,
  limit = 12,
  category,
  status,
  includeDrafts,
  sort_by,
  sort_dir,
} = {}) => {
  const { data } = await api.get(
    buildBlogQuery({
      q,
      page,
      limit,
      category,
      status,
      includeDrafts,
      sort_by,
      sort_dir,
    })
  );
  return unwrap(data);
};

/** blogs home */
export const fetchBlogsHome = async () => {
  const { data } = await api.get(BLOGS_HOME);
  return unwrap(data);
};

/**api blogs search */
export const searchBlogs = async (q) => {
  const query = new URLSearchParams();
  if (q) query.set("q", q);
  const { data } = await api.get(`${BLOGS_SEARCH}?${query.toString()}`);
  return unwrap(data);
};

/** api blogs slug or api blogs */
export const fetchBlogByIdOrSlug = async (idOrSlug) => {
  const { data } = await api.get(`${BLOGS}/${idOrSlug}`);
  return unwrap(data);
};

/** POST api blogs — create */
export const createBlog = async (payload) => {
  const { data } = await api.post(BLOGS, payload);
  return unwrap(data);
};

/** POST api blogs blogId update */
export const updateBlog = async (blogId, payload) => {
  const { data } = await api.post(`${BLOGS}/${blogId}`, payload);
  return unwrap(data);
};

/** delete api blogs */
export const deleteBlog = async (blogId) => {
  const { data } = await api.delete(`${BLOGS}/${blogId}`);
  return unwrap(data);
};
